<template>
  <div>
    <b-card title="Bienvenue sur AS Gestion de la société :">
      <b-row class="align-items-start">
        <b-col
          v-if="setting.imageBase64"
          cols="auto"
          class="pr-3 mb-2 mb-md-0 flex-shrink-0"
        >
          <b-img
            :src="setting.imageBase64"
            fluid
            alt="Logo société"
            style="max-height: 120px; max-width: 160px; width: auto; object-fit: contain;"
          />
        </b-col>
        <b-col>
          <h4 class="text-primary">
            {{ setting.societe }}
          </h4>
          <b-card-text class="mb-25">
            {{ setting.adresse1 }}
          </b-card-text>
          <b-card-text class="mb-25" v-if="setting.adresse2">
            {{ setting.adresse2 }}
          </b-card-text>
          <b-card-text class="mb-25" v-if="setting.adresse3">
            {{ setting.adresse3 }}
          </b-card-text>
          <b-card-text class="mb-0">
            {{ setting.codepostal }} {{ setting.ville }}
          </b-card-text>
          <b-card-text class="mb-0">
            {{ setting.pays }}
          </b-card-text>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText, BLink, BButton, BImg, BRow, BCol } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PouchDB from 'pouchdb'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BButton,
    BImg,
    BRow,
    BCol,
  },
  data() {
    return {
      setting: JSON.parse(localStorage.setting)
    }
  },
  created() {
    
  },
  methods: {
    currentpath() {
      alert(window.location.origin)
    }
  }
}
</script>

<style>

</style>
